require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// /Users/gebb/Desktop/live/~/core-js/library/modules/es7.symbol.async-iterator.js
// module id = 66
// module chunks = 0